<template>
    <footer class="about w-100 text-center" 
        :style="{
            backgroundColor: activeOwner.id == 1 ? 'white !important':'#f5f9fb !important' 
        }">
        <p class="my-2" style="font-size: 0.9rem">Credit {{ new Date().getFullYear() }}</p>
    </footer>
</template>

<script>
    import { mapState } from "pinia"
    import { useGeneralStore } from '@/stores/GeneralStore'

    export default {
        name: "AdminFooter",
        components: {
        },
        data(){
            return{
                items: [
                    {
                        items: [
                            {
                                label: 'Settings',
                                icon: 'pi pi-cog',
                                command: () => {
                                    this.$router.push({ path: '/admin/user/setting' })
                                }
                            },
                            {
                                label: 'Logout',
                                icon: 'pi pi-sign-out',
                                command: () => {
                                    this.logout();
                                }
                            }
                        ]
                    }
                ],
                logo: '',
            }
        },
        computed:{
            ...mapState( useGeneralStore, ['activeOwner']),
        },
        methods: {
        }
    }

</script>